import { render, staticRenderFns } from "./materialPriceData.vue?vue&type=template&id=473d5593&scoped=true"
import script from "./materialPriceData.vue?vue&type=script&lang=js"
export * from "./materialPriceData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d5593",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473d5593')) {
      api.createRecord('473d5593', component.options)
    } else {
      api.reload('473d5593', component.options)
    }
    module.hot.accept("./materialPriceData.vue?vue&type=template&id=473d5593&scoped=true", function () {
      api.rerender('473d5593', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/materialPriceData.vue"
export default component.exports